<template>
  <h3 class="font-semibold text-gray-700 text-xl">Cosechas</h3>
  <div id="chart4">
    <apexchart
      type="line"
      height="350"
      width="100%"
      :options="options"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "PRODReportingProcessShowReportsGraphicsHarvestMonthly",
  components: {
    apexchart: VueApexCharts
  },
  props: {
    data: { required: true }
  },
  data() {},
  computed: {
    series() {
      return [
        {
          name: "",
          data: this.data_weekly
        }
      ];
    },
    options() {
      return {
        chart: {
          type: "line",
          height: 350
        },
        dataLabels: {
          enabled: false
        },
        markers: {
          size: 0,
          style: "hollow"
        },
        colors: ["#65A30D"],
        xaxis: {
          tickPlacement: "between",
          group: {
            groups: this.groups,
            style: {
              fontSize: "14px",
              fontWeight: 500
            }
          }
        },
        yaxis: {
          title: { text: "Kilogramos" },
          tickPlacement: "between",
          labels: {
            formatter: function (val) {
              return this.numberWithPrecision(val);
            }.bind(this)
          }
        },
        tooltip: {
          x: {
            formatter: function (val) {
              return `Sem ${val}`;
            }
          }
        }
      };
    },
    data_weekly() {
      return Object.values(this.data)
        .flat()
        .map(harvest => {
          return {
            x: `${harvest[0]}`,
            y: harvest[1]
          };
        });
    },
    groups() {
      return Object.keys(this.data).map(key => {
        return {
          title: key,
          cols: this.data[key].length
        };
      });
    }
  }
};
</script>
